import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from 'react-hot-toast';
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs"; 
import Services from "./pages/Services";
import VRGamingForm from "./pages/VRGamingForm";
import Gallery from "./pages/Gallery";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import PrivateTheatre from "./pages/PrivateTheatre";
import BirthdayCelebration from "./pages/BirthdayCelebration";
import AnniversaryCelebration from "./pages/AnniversaryCelebration";
import Location from "./pages/Location";
import AddOnExperiences from "./pages/AddOnExperiences";


import SingleBlog from "./pages/SingleBlog";
import BlogManager from "./pages/BlogManager";


import FloatingActions from "./pages/FloatingActions";
import RoomCard from "./pages/RoomCard";
import RoomCard1 from "./pages/RoomCards1";
import Pillar from "./pages/Pillar";
import OccasionSelection from "./pages/OccasionSelection";
import VRGamingg from "./pages/VRGamingg";
import EventServices from "./pages/EventServices";
import ServiceBookingForm from "./pages/ServiceBookingForm";
import RefundPolicy from "./pages/RefundPolicy";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CancellationPolicy from "./pages/CancellationPolicy";
import ScrollToTop from "./pages/ScrollToTop";
import LoginPage from './pages/LoginPage/LoginPage';
import NotFoundPage from './pages/404'; 
import Gaming from './pages/Gaming';
import FAQPage from './pages/FAQPage';
import AdminOrderList from './pages/AdminOrderList';
import AdminOrderListFinal from './pages/AdminOrderListFinal';
import AdminPanel from './pages/Dashboard/AdminPanel';
import AdminPanelRoomCard from './pages/Dashboard/AdminPanelRoomCard';
import BookingStatus  from "./pages/BookingStatus";
import BookingSuccess from "./pages/BookingSuccess";
import PaymentFailed  from "./pages/PaymentFailed";
import CustomerDB from "./pages/SuperAdmin/CustomerDB";

// Super Admin imports
import SuperAdminLogin from "./pages/SuperAdminLogin/SuperAdminLogin";
import SuperAdminDashboard from "./pages/SuperAdmin/SuperAdminDashboard";
import SuperAdminRoomControl from "./pages/SuperAdmin/SuperAdminRoomControl";
import FreezedDatabase from "./pages/SuperAdmin/FreezedDatabase";
import SuperAdminFrozenOrders from "./pages/SuperAdmin/SuperAdminFrozenOrders";
import StockManagement from "./pages/SuperAdmin/StockManagement";

import InvoiceMaker from "./pages/InvoiceMaker.jsx";

// Admin imports
import AdminLogin from "./pages/Admin/AdminLogin";
import AdminDashboard from "./pages/Admin/AdminDashboard";

// Staff imports
import StaffLogin from "./pages/StaffLogin/StaffLogin";
import StaffDashboard from "./pages/StaffLogin/StaffDashboard";

import StaffManagement from "./pages/StaffManagement";
import TransferContact from "./pages/TransferContact";

import Extraaddon from "./pages/extraaddon";

// ==========================================
// 🔒 PROTECTED ROUTE COMPONENTS
// ==========================================

// Generic protected route (fallback)
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return children;
};

// SuperAdmin Protection - Only SuperAdmins can access
const SuperAdminProtected = ({ children }) => {
  const isAuth = localStorage.getItem("superAdminAuth") === "true";
  const location = useLocation();
  
  if (!isAuth) {
    return <Navigate to="/superadmin/login" state={{ from: location.pathname }} replace />;
  }
  return children;
};

// Staff Protection - Only Staff can access
const StaffProtected = ({ children }) => {
  const isAuth = localStorage.getItem("staffAuth") === "true";
  const location = useLocation();
  
  if (!isAuth) {
    return <Navigate to="/StaffLogin" state={{ from: location.pathname }} replace />;
  }
  return children;
};

// Admin Protection - Only Admins can access
const AdminProtected = ({ children }) => {
  const isAuth = localStorage.getItem("adminAuth") === "true";
  const location = useLocation();
  
  if (!isAuth) {
    return <Navigate to="/AdminLogin" state={{ from: location.pathname }} replace />;
  }
  return children;
};

// ==========================================
// 🎯 ROLE-BASED ACCESS CONTROL
// ==========================================

// AdminPanel Access: SuperAdmin OR Admin can access
const AdminPanelProtected = ({ children }) => {
  const isAdmin = localStorage.getItem("adminAuth") === "true";
  const isSuperAdmin = localStorage.getItem("superAdminAuth") === "true";
  const location = useLocation();
  
  // Allow access if either Admin OR SuperAdmin is authenticated
  if (!isAdmin && !isSuperAdmin) {
    // Redirect based on role
    if (isSuperAdmin) return <Navigate to="/superadmin/dashboard" replace />;
    if (localStorage.getItem("staffAuth") === "true") return <Navigate to="/StaffDashboard" replace />;
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return children;
};

// Staff Management: Staff + Admin + SuperAdmin can access
const StaffManagementProtected = ({ children }) => {
  const isStaff = localStorage.getItem("staffAuth") === "true";
  const isAdmin = localStorage.getItem("adminAuth") === "true";
  const isSuperAdmin = localStorage.getItem("superAdminAuth") === "true";
  const location = useLocation();
  
  if (!isStaff && !isAdmin && !isSuperAdmin) {
    // Redirect based on role or to login
    if (isStaff) return <Navigate to="/StaffDashboard" replace />;
    if (isAdmin) return <Navigate to="/AdminDashboard" replace />;
    if (isSuperAdmin) return <Navigate to="/superadmin/dashboard" replace />;
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return children;
};

// Admin Only: Admin + SuperAdmin can access (InvoiceMaker, CustomerDB, RoomCardControl)
const AdminOnlyProtected = ({ children }) => {
  const isAdmin = localStorage.getItem("adminAuth") === "true";
  const isSuperAdmin = localStorage.getItem("superAdminAuth") === "true";
  const location = useLocation();
  
  if (!isAdmin && !isSuperAdmin) {
    // Redirect based on role
    if (isSuperAdmin) return <Navigate to="/superadmin/dashboard" replace />;
    if (localStorage.getItem("staffAuth") === "true") return <Navigate to="/StaffDashboard" replace />;
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return children;
};

// Transfer Contact: Staff + Admin + SuperAdmin can access
const TransferContactProtected = ({ children }) => {
  const isStaff = localStorage.getItem("staffAuth") === "true";
  const isAdmin = localStorage.getItem("adminAuth") === "true";
  const isSuperAdmin = localStorage.getItem("superAdminAuth") === "true";
  const location = useLocation();
  
  if (!isStaff && !isAdmin && !isSuperAdmin) {
    if (isStaff) return <Navigate to="/StaffDashboard" replace />;
    if (isAdmin) return <Navigate to="/AdminDashboard" replace />;
    if (isSuperAdmin) return <Navigate to="/superadmin/dashboard" replace />;
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return children;
};

// ==========================================
// 🚫 ANTI-TAMPERING: Redirect logged-in users away from login pages
// ==========================================

const SuperAdminPublic = ({ children }) => {
  const isAuth = localStorage.getItem("superAdminAuth") === "true";
  if (isAuth) return <Navigate to="/superadmin/dashboard" replace />;
  return children;
};

const StaffPublic = ({ children }) => {
  const isAuth = localStorage.getItem("staffAuth") === "true";
  if (isAuth) return <Navigate to="/StaffDashboard" replace />;
  return children;
};

const AdminPublic = ({ children }) => {
  const isAuth = localStorage.getItem("adminAuth") === "true";
  if (isAuth) return <Navigate to="/AdminDashboard" replace />;
  return children;
};

// ==========================================
// ✅ MAIN CONTENT WITH LOCATION
// ==========================================
const AppContent = () => {
  const location = useLocation();

  const allowedPaths = [
    "/",
    "/Gallery",
    "/EventServices",
    "/Gaming",
    "/Contact",
    "/AboutUs",
    "/Services"
  ];

  const showFloating = allowedPaths.includes(location.pathname);

  return (
    <>
      <Navbar />
      <ScrollToTop />

      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/AboutUs" element={<AboutUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />
          <Route path="/private-theatre" element={<PrivateTheatre />} />
            <Route path="/birthday-celebration" element={<BirthdayCelebration />} />
              <Route path="/anniversary-celebration" element={<AnniversaryCelebration />} />
                
               <Route
  path="/add-on-experiences"
  element={<AddOnExperiences />}
/>
                
                <Route
        path="/locations/navalur/"
        element={<Location />}
      />
                
                
        <Route path="/gaming" element={<Gaming />} />
        <Route path="/FAQPage" element={<FAQPage />} />
        <Route path="/RoomCard" element={<RoomCard />} />
        <Route path="/RoomCard1" element={<RoomCard1 />} />
        <Route path="/OccasionSelection" element={<OccasionSelection />} />
        <Route path="/VRGamingForm" element={<VRGamingForm />} />
        <Route path="/VRGamingg" element={<VRGamingg />} />
        <Route path="/EventServices" element={<EventServices />} />
        <Route path="/ServiceBookingForm" element={<ServiceBookingForm />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cancellation-policy" element={<CancellationPolicy />} />
        <Route path="/login" element={<LoginPage />} />
          
          
          
          <Route path="/Extraaddon" element={<Extraaddon />} />
            
            

        {/* Payment Flow Routes */}
        <Route path="/booking-status" element={<BookingStatus />} />
        <Route path="/booking-status/:bookingIdParam" element={<BookingStatus />} />
        <Route path="/booking-success" element={<BookingSuccess />} />
        <Route path="/booking-success/:bookingIdParam" element={<BookingSuccess />} />
        <Route path="/payment-failed" element={<PaymentFailed />} />
        <Route path="/payment-failed/:bookingIdParam" element={<PaymentFailed />} />
          
          
        <Route path="/blog/:slug" element={<SingleBlog />} />
        <Route path="/admin/blog-manager" element={<BlogManager />} />
          
          
          
          
          
          

        {/* ==========================================
            🔒 STAFF MANAGEMENT - Staff + Admin + SuperAdmin
           ========================================== */}
        <Route 
          path="/StaffManagement" 
          element={
            <StaffManagementProtected>
              <StaffManagement />
            </StaffManagementProtected>
          } 
        />

        {/* ==========================================
            🔒 TRANSFER CONTACT - Staff + Admin + SuperAdmin
           ========================================== */}
        <Route 
          path="/TransferContact" 
          element={
            <TransferContactProtected>
              <TransferContact />
            </TransferContactProtected>
          } 
        />

        {/* ==========================================
            🔒 INVOICE MAKER - Admin + SuperAdmin ONLY
           ========================================== */}
        <Route 
          path="/InvoiceMaker" 
          element={
            <AdminOnlyProtected>
              <InvoiceMaker />
            </AdminOnlyProtected>
          } 
        />

        {/* ==========================================
            🔒 SUPER ADMIN ROUTES - Protected
           ========================================== */}
        <Route 
          path="/superadmin/login" 
          element={
            <SuperAdminPublic>
              <SuperAdminLogin />
            </SuperAdminPublic>
          } 
        />
        <Route
          path="/superadmin/dashboard"
          element={
            <SuperAdminProtected>
              <SuperAdminDashboard />
            </SuperAdminProtected>
          }
        />
        {/* ✅ Room Card Control - Now accessible by Admin AND SuperAdmin */}
        <Route
          path="/superadmin/roomcard-control"
          element={
            <AdminOnlyProtected>
              <SuperAdminRoomControl />
            </AdminOnlyProtected>
          }
        />
        <Route
          path="/superadmin/customer-db"
          element={
            <AdminOnlyProtected>
              <CustomerDB />
            </AdminOnlyProtected>
          }
        />
        <Route
          path="/superadmin/freezed-db"
          element={
            <SuperAdminProtected>
              <FreezedDatabase />
            </SuperAdminProtected>
          }
        />
        <Route
          path="/superadmin/stock-management"
          element={
            <SuperAdminProtected>
              <StockManagement />
            </SuperAdminProtected>
          }
        />
        <Route
          path="/SuperAdminFrozenOrders"
          element={
            <SuperAdminProtected>
              <SuperAdminFrozenOrders />
            </SuperAdminProtected>
          }
        />

        {/* ==========================================
            🔒 STAFF ROUTES - Protected
           ========================================== */}
        <Route 
          path="/StaffLogin" 
          element={
            <StaffPublic>
              <StaffLogin />
            </StaffPublic>
          } 
        />
        <Route 
          path="/StaffDashboard" 
          element={
            <StaffProtected>
              <StaffDashboard />
            </StaffProtected>
          } 
        />

        {/* ==========================================
            🔒 ADMIN ROUTES - Protected
           ========================================== */}
        <Route 
          path="/AdminLogin" 
          element={
            <AdminPublic>
              <AdminLogin />
            </AdminPublic>
          } 
        />
        <Route 
          path="/AdminDashboard" 
          element={
            <AdminProtected>
              <AdminDashboard />
            </AdminProtected>
          } 
        />
        
        {/* ==========================================
            🔒 ADMIN PANEL - Accessible by Admin AND SuperAdmin
           ========================================== */}
        <Route 
          path="/AdminPanel" 
          element={
            <AdminPanelProtected>
              <AdminPanel />
            </AdminPanelProtected>
          } 
        />
        
        <Route 
          path="/AdminPanelRoomCard" 
          element={
            <AdminProtected>
              <AdminPanelRoomCard />
            </AdminProtected>
          } 
        />
        <Route 
          path="/Pillar" 
          element={
            <AdminProtected>
              <Pillar />
            </AdminProtected>
          } 
        />
        <Route 
          path="/AdminOrderList" 
          element={
            <AdminProtected>
              <AdminOrderList />
            </AdminProtected>
          } 
        />
        <Route 
          path="/AdminOrderListFinal" 
          element={
            <AdminProtected>
              <AdminOrderListFinal />
            </AdminProtected>
          } 
        />

        {/* Catch-all - 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      
      <Footer />
      {showFloating && <FloatingActions />}
    </>
  );
};

function App() {
  return (
    <>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
      <Toaster position="top-right" />
    </>
  );
}

export default App;